import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { THEFT_REGISTRIES_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getTheftRegistryAction = createAsyncThunk(
    'order/getTheftRegistryAction',
    async (theftRegistryId, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ THEFT_REGISTRIES_PATH }/${ theftRegistryId }/details`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getTheftRegistrySlice = createSlice({
    name: 'getTheftRegistrySlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getTheftRegistryAction.pending, () => STATE__API__STARTED);
        builder.addCase(getTheftRegistryAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getTheftRegistryAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getTheftRegistryState = (state) => state.order.getTheftRegistry;
export default getTheftRegistrySlice.reducer;
